<template>
  <div class='notification-block'>
    <div class='notification-container'>
      <div class='notification-logo'>
        <img alt='info' src='static/img/exclamation-black.svg' />
      </div>
      <div class='notification-content'>
        <div v-html="shutdownAnnouncement"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MPayShutdownAnnouncement',
  data: () => ({
    shutdownAnnouncement: 'Oversee your company’s transaction flow from a new simple platform, try out the <a href="https://portal.klix.app">Business Portal</a>. Merchant console will be available till 31.12.2021.',
  }),
};
</script>

<style scoped>
.notification-block {
  width: 100%;
  background-color: #ffd166;
  min-height: 70px;
  display: grid;
}

.notification-content {
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.07px;
  color: #212121;
  flex-grow: 4;
  flex-shrink: 4;
  align-self: center;
}

.notification-content div {
  width: 750px;
  margin: 5px;
}

.notification-container {
  display: flex;
}

.notification-logo {
  align-self: center;
  flex-grow: 4;
  flex-shrink: 2;
}

.notification-logo img {
  float: right;
  margin: 0 15px;
}

.notification-block--mobile .notification-logo,
.notification-block--mobile.notification-content {
  flex-shrink: unset;
  flex-grow: unset;
}

.notification-block--mobile .notification-logo img {
  float: none;
}

.notification-block--mobile .notification-logo {
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/components/MPayShutdownAnnouncement.vue